import React, { useEffect, useMemo, useRef, useState } from "react";
// 分享弹窗恢复时：在上一行 import 中加入 useCallback，并增加以下 import
// import { get_shareInfo } from "@/api/referral"; // 并入下一条 referral import
// import ShareModal from "components/App/shareModal";
// import { getInviteUrl } from "@/utils/method";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
import jia from "assets/images/home/jia.png";
import jian from "assets/images/home/jian.png";
import Immediate from "assets/images/home/Immediate.png";
import plv1 from "assets/images/affiliate/partner-levels/vip1.png";
import plv2 from "assets/images/affiliate/partner-levels/vip2.png";
import plv3 from "assets/images/affiliate/partner-levels/vip3.png";
import plv4 from "assets/images/affiliate/partner-levels/vip4.png";
import plv5 from "assets/images/affiliate/partner-levels/vip5.png";
import plv6 from "assets/images/affiliate/partner-levels/vip6.png";
import plv7 from "assets/images/affiliate/partner-levels/vip7.png";
import affiliateArcDivider from "assets/images/referral/partner-level-ui/affiliate-horizontal-divider.png";
import affiliateChevronLeft from "assets/images/referral/partner-level-ui/affiliate-chevron-left.png";
import affiliateChevronRight from "assets/images/referral/partner-level-ui/affiliate-chevron-right.png";
import flow_y from "assets/images/home/flow_y.png";
import flow_n from "assets/images/home/flow_n.png";
import partner1 from "assets/images/home/partner1.png";
import partner2 from "assets/images/home/partner2.png";
import partner3 from "assets/images/home/partner3.png";
import partner4 from "assets/images/home/partner4.png";
import img4 from "assets/images/home/04.png";
import pre from "assets/images/home/pre.png";
import preDis from "assets/images/home/preDis.png";
import next from "assets/images/home/next.png";
import nextDis from "assets/images/home/nextDis.png";
import { Collapse, Anchor, Tooltip } from 'antd';
import { QuestionCircleOutlined } from "@ant-design/icons";
import { get_profileInfo, get_inviteVipLevelsV2, get_inviteVipProgress, getReferralRule } from "@/api/referral";
import ReferralHierarchy from "@/components/Pages/referral/banner/ReferralHierarchy";
import ReferralRules from "@/components/Pages/referral/banner/ReferralRules";
import { formatEffectiveUserSummary } from "@/components/Pages/referral/utils/formatEffectiveUserSummary";

/** 与 ReferralRules 一致：`/sapi/v4/.../invite-rules/{activity}` */
const REFERRAL_RULE_ACTIVITY_KEY = "INVITE_DEPOSIT_TRADE_REWARD";

const { Panel } = Collapse;
const {XtContext,XtAuth} = Context;
const {getOrigin, getUrl} = Util;
const {useTranslation, useDocumentWidth} = Hooks;

function Content() {
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const [appState] = React.useContext(XtContext);
  const { loginStatus, userInfo, lang } = appState;
  const affiliatePageDir =
    lang === "ar" || String(lang || "").toLowerCase().startsWith("ar") ? "rtl" : "ltr";
  // 分享弹窗恢复时解构增加: lang
  const {affiliate_content, faqContent, recommendTitle, faq, faqItem, jianImg, jiaImg, faqItemP, immediate, immediateTitle, logIn, commissioner, operate, level, partnershipRank,
    partner, partnerTitle, partnerDiagramWrap, partnerDiagramImg, partner_text, partner_text_title, partner_text_desc, partnerPre, partnerNext} = styles
  const [partnerLevel, setPartnerLevel] = useState([]);
  /** 与邀请页「Active user:」后文案同源：接口 effectiveUser 结构化字段 + i18n */
  const [inviteRuleEffectiveUser, setInviteRuleEffectiveUser] = useState(null);

  const [loginQuery, setLoginQuery] = useState("");

  const [activeIndex, setActiveIndex] = useState(1)
  const [profileInfo, setProfileInfo] = useState({})
  const [currentVipLevel, setCurrentVipLevel] = useState(0);
  const [viewLevelIndex, setViewLevelIndex] = useState(0);
  // --- 分享弹窗（Invite Now 现为 onInviteNow 跳转 /referral；恢复时取消下面注释并改按钮 onClick 为 onShare）---
  // const [isShowShareModal, setIsShowShareModal] = useState(false);
  // const [shareInfo, setShareInfo] = useState(null);
  // const [inviteShareUrl, setInviteShareUrl] = useState("");
  // const fetchShareInfo = useCallback(async () => {
  //   try {
  //     const list = await get_shareInfo();
  //     const arr = Array.isArray(list) ? list : list?.result ?? list?.data ?? [];
  //     let info = null;
  //     if (lang === "zh-HK") info = arr.find((_) => (_.lang || "").toLowerCase() === "zh-hk");
  //     else if (lang === "zh-CN") info = arr.find((_) => (_.lang || "").toLowerCase() === "zh");
  //     else info = arr.find((_) => (_.lang || "").toLowerCase() === (lang || "").toLowerCase());
  //     setShareInfo(info || null);
  //   } catch (_) {
  //     setShareInfo(null);
  //   }
  // }, [lang]);
  // const onShare = async () => {
  //   if (loginStatus != 1) {
  //     window.location.href = getUrl("/accounts/login" + loginQuery);
  //     return;
  //   }
  //   let info = profileInfo;
  //   if (!info?.inviteCode) {
  //     info = await getProfileInfo();
  //   }
  //   if (!info?.inviteCode) return;
  //   setInviteShareUrl(getInviteUrl(info.inviteCode, lang));
  //   fetchShareInfo();
  //   setIsShowShareModal(true);
  // };
  // const onShareClose = () => {
  //   setIsShowShareModal(false);
  // };

  const dynamicIndex = useRef(1)
  const timer = useRef()

  useEffect(()=>{
    setLoginQuery("?backurl="+encodeURIComponent(location.href));
    const getData = async() => {
      getPartnerLevel()
    }
    getData()
    startTimer(); // 开启定时器
    return () => {
      stopTimer();
    };
  },[]);

  useEffect(()=>{
    const getData = async() => {
      if (loginStatus == 1) {
        await Promise.all([getProfileInfo(), getCurrentVipProgress()]);
      } else {
        setCurrentVipLevel(0);
      }
    }
    getData()
  },[loginStatus]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getReferralRule({
          activity: REFERRAL_RULE_ACTIVITY_KEY,
          isPublic: loginStatus !== 1,
        });
        if (cancelled) return;
        const rules = data?.invitationRules ?? data;
        setInviteRuleEffectiveUser(rules?.effectiveUser ?? null);
      } catch (_) {
        if (!cancelled) setInviteRuleEffectiveUser(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [loginStatus]);

  const inviteRuleActiveUserSummary = useMemo(
    () => formatEffectiveUserSummary(inviteRuleEffectiveUser, t),
    [inviteRuleEffectiveUser, t]
  );

  const getProfileInfo = async() => {
    const profileInfo = await get_profileInfo()
    setProfileInfo(profileInfo || {})
    return profileInfo || {}
  }

  const getCurrentVipProgress = async() => {
    const res = await get_inviteVipProgress();
    const currentLevelValue =
      res?.result?.currentVipLevel != null
        ? Number(res.result.currentVipLevel)
        : res?.currentVipLevel != null
          ? Number(res.currentVipLevel)
          : 0;
    setCurrentVipLevel(Number.isFinite(currentLevelValue) ? currentLevelValue : 0);
  }

  // 开启定时器
  const startTimer = () => {
    timer.current = setInterval(() => {
      setDynamicIndex()
    }, 2000);
  };

  // 关闭
  const stopTimer = () => {
    clearInterval(timer.current);
  };

  const setDynamicIndex = () => {
    dynamicIndex.current = (dynamicIndex.current == 4 ? 1 : dynamicIndex.current + 1)
    setActiveIndex(dynamicIndex.current)
  }

  useEffect(()=>{
    stopTimer()
    dynamicIndex.current = activeIndex
    startTimer()
  },[activeIndex])

  const getPartnerLevel = async() => {
    const res = await get_inviteVipLevelsV2();
    const list = Array.isArray(res?.result) ? res.result : Array.isArray(res) ? res : [];
    setPartnerLevel(list);
  }

  const partnerLevelRows = useMemo(() => {
    const toPercentLabel = (num) => {
      if (!Number.isFinite(num)) return "--";
      const pct = num > 0 && num <= 1 ? num * 100 : num;
      let s = pct.toFixed(8);
      if (s.includes(".")) {
        s = s.replace(/0+$/, "").replace(/\.$/, "");
      }
      return s;
    };

    const formatPercentValue = (value) => {
      return toPercentLabel(Number(value || 0));
    };

    const formatAiCopyPercentValue = (value) => {
      if (value == null || value === "") return "--";
      return toPercentLabel(Number(value));
    };

    const formatRebateRates = (commissionRate) => {
      if (!Array.isArray(commissionRate) || commissionRate.length === 0) return "--";
      return [...commissionRate]
        .sort((a, b) => Number(a?.inviteLayer || 0) - Number(b?.inviteLayer || 0))
        .map((item) => {
          const value = formatPercentValue(item?.cfdCommissionRate);
          return value === "--" ? value : `${value}%`;
        })
        .filter((item) => item !== "--")
        .join("、");
    };

    const formatRebateTiers = (commissionRate) => {
      if (!Array.isArray(commissionRate) || commissionRate.length === 0) return [];
      return [...commissionRate]
        .sort((a, b) => Number(a?.inviteLayer || 0) - Number(b?.inviteLayer || 0))
        .map((item) => {
          const value = formatPercentValue(item?.cfdCommissionRate);
          if (value === "--") return null;
          const layer = Number(item?.inviteLayer || 0);
          return { layer: Number.isFinite(layer) ? layer : 0, text: `${value}%` };
        })
        .filter(Boolean);
    };

    const aiCopyRebateRateIsPresent = (raw) => {
      if (raw == null || raw === "") return false;
      const n = Number(raw);
      return Number.isFinite(n) && n !== 0;
    };

    const formatAiCopyRebateRates = (commissionRate) => {
      if (!Array.isArray(commissionRate) || commissionRate.length === 0) return "--";
      const parts = [...commissionRate]
        .sort((a, b) => Number(a?.inviteLayer || 0) - Number(b?.inviteLayer || 0))
        .map((row) => {
          if (!aiCopyRebateRateIsPresent(row?.aiCopyTradeRebateRate)) return null;
          const value = formatAiCopyPercentValue(row?.aiCopyTradeRebateRate);
          return value === "--" ? null : `${value}%`;
        })
        .filter(Boolean);
      return parts.length ? parts.join("、") : "--";
    };

    const formatAiCopyRebateTiers = (commissionRate) => {
      if (!Array.isArray(commissionRate) || commissionRate.length === 0) return [];
      return [...commissionRate]
        .sort((a, b) => Number(a?.inviteLayer || 0) - Number(b?.inviteLayer || 0))
        .map((row) => {
          if (!aiCopyRebateRateIsPresent(row?.aiCopyTradeRebateRate)) return null;
          const value = formatAiCopyPercentValue(row?.aiCopyTradeRebateRate);
          if (value === "--") return null;
          const layer = Number(row?.inviteLayer || 0);
          return { layer: Number.isFinite(layer) ? layer : 0, text: `${value}%` };
        })
        .filter(Boolean);
    };

    return [...(partnerLevel || [])].map((item, index) => ({
      key: item?.vipLevelId ?? item?.vipLevel ?? index,
      level: item?.vipLevel ?? index + 1,
      directValidCount: item?.directValidUserCount ?? 0,
      openPositionMargin: item?.openPositionMargin ?? 0,
      rebateRates: formatRebateRates(item?.commissionRate),
      rebateTiers: formatRebateTiers(item?.commissionRate),
      aiCopyRebateRates: formatAiCopyRebateRates(item?.commissionRate),
      aiCopyRebateTiers: formatAiCopyRebateTiers(item?.commissionRate),
      vipCode: item?.vipCode || "",
      vipName: item?.vipName || "",
    }));
  }, [partnerLevel]);

  const currentLevel = loginStatus == 1 ? Number(currentVipLevel || 0) : 0;

  useEffect(() => {
    if (!partnerLevelRows.length) return;
    setViewLevelIndex((i) => Math.max(0, Math.min(i, partnerLevelRows.length - 1)));
  }, [partnerLevelRows.length]);

  useEffect(() => {
    if (!Array.isArray(partnerLevel) || !partnerLevel.length) return;
    if (loginStatus == 1 && currentLevel > 0) {
      const idx = partnerLevel.findIndex(
        (r) => Number(r?.vipLevel ?? 0) === currentLevel
      );
      if (idx >= 0) setViewLevelIndex(idx);
    }
  }, [loginStatus, currentLevel, partnerLevel]);

  const renderLevelImg = (levelNum) => {
    const levelIconMap = {
      1: plv1,
      2: plv2,
      3: plv3,
      4: plv4,
      5: plv5,
      6: plv6,
      7: plv7,
    };
    return levelIconMap[Number(levelNum)] || plv7;
  }

  const renderExplainTitle = () => {
    if (activeIndex == 1) {
      return t("home.applyToPartner")
    } else if (activeIndex == 2) {
      return t("home.applyToPartner1")
    } else if (activeIndex == 3) {
      return t("home.applyToPartner2")
    } else if (activeIndex == 4) {
      return t("home.applyToPartner3")
    };
  }

  const renderExplainDesc = () => {
    if (activeIndex == 1) {
      return t("home.applyToPartnerTip1")
    } else if (activeIndex == 2) {
      return t("home.applyToPartner1Tip")
    } else if (activeIndex == 3) {
      return t("home.applyToPartner2Tip")
    } else if (activeIndex == 4) {
      return t("home.applyToPartner3Tip")
    }
  }

  const renderRotateImg = () => {
    if (activeIndex == 1) {
      return partner1
    } else if (activeIndex == 2) {
      return partner2
    } else if (activeIndex == 3) {
      return partner3
    } else if (activeIndex == 4) {
      return partner4
    }
  }

  const onInviteNow = () => {
    window.location.href = getUrl("/referral");
  };

  const rebateTierGridPlacement = (index, total, packFromStart) => {
    const row = Math.floor(index / 3) + 1;
    const idxInRow = index % 3;
    if (row === 1) {
      if (packFromStart) {
        return { gridRow: row, gridColumn: idxInRow + 1 };
      }
      const nFirst = Math.min(3, total);
      const startCol = 4 - nFirst;
      return { gridRow: row, gridColumn: startCol + idxInRow };
    }
    return { gridRow: row, gridColumn: idxInRow + 1 };
  };

  const renderPartnerLevelView = () => {
    if (!partnerLevelRows.length) return null;
    const idx = viewLevelIndex;
    const item = partnerLevelRows[idx];
    if (!item) return null;
    const prevRow = partnerLevelRows[idx - 1];
    const nextRow = partnerLevelRows[idx + 1];
    const isCurrent = Number(item.level) === currentLevel;
    const canPrev = idx > 0;
    const canNext = idx < partnerLevelRows.length - 1;
    const rebatePackFromStart = affiliatePageDir === "rtl";
    return (
      <div
        key={item.key}
        className={`${styles.levelPartnerBlock} ${isCurrent ? styles.levelPartnerBlockActive : ""}`}
      >
        <div className={styles.levelPartnerBlockTop}>
          <button
            type="button"
            className={`${styles.levelPartnerChevron} ${!canPrev ? styles.levelPartnerChevronDisabled : ""}`}
            disabled={!canPrev}
            onClick={() => canPrev && setViewLevelIndex((i) => i - 1)}
            aria-label={t("home.affiliateLevelPrev")}
          >
            <img src={affiliateChevronLeft} alt="" className={styles.levelPartnerChevronImg} />
          </button>
          <div className={styles.levelPartnerBadgeWrap}>
            <img
              className={styles.levelPartnerBadgeImg}
              src={renderLevelImg(item.level)}
              alt={`Level ${item.level}`}
            />
          </div>
          <button
            type="button"
            className={`${styles.levelPartnerChevron} ${!canNext ? styles.levelPartnerChevronDisabled : ""}`}
            disabled={!canNext}
            onClick={() => canNext && setViewLevelIndex((i) => i + 1)}
            aria-label={t("home.affiliateLevelNext")}
          >
            <img src={affiliateChevronRight} alt="" className={styles.levelPartnerChevronImg} />
          </button>
        </div>
        <div className={styles.levelPartnerTrack}>
          <div className={styles.levelPartnerTrackInner}>
            <img
              src={affiliateArcDivider}
              alt=""
              className={styles.levelPartnerArcImg}
            />
            {/* 中间与徽章/弧图高光对齐 50%；左右保持相对原中点 117 的间距 (117-21)、(211-117) */}
            <div className={styles.levelPartnerLabelsRow}>
              <div
                className={`${styles.levelPartnerLabelSlot} ${!prevRow ? styles.levelPartnerNodeMuted : ""}`}
                style={{ left: `${50 - ((117 - 21) / 264) * 100}%` }}
              >
                <span className={styles.levelPartnerNodeLv}>
                  {prevRow ? `Lv.${prevRow.level}` : ""}
                </span>
              </div>
              <div className={`${styles.levelPartnerLabelSlot} ${styles.levelPartnerNodeSlotActive}`} style={{ left: "50%" }}>
                <span className={styles.levelPartnerNodeLv}>Lv.{item.level}</span>
                {isCurrent && (
                  <span className={styles.levelPartnerNodeSub}>{t("home.currentLevelTag")}</span>
                )}
              </div>
              <div
                className={`${styles.levelPartnerLabelSlot} ${!nextRow ? styles.levelPartnerNodeMuted : ""}`}
                style={{ left: `${50 + ((211 - 117) / 264) * 100}%` }}
              >
                <span className={styles.levelPartnerNodeLv}>
                  {nextRow ? `Lv.${nextRow.level}` : ""}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.levelPartnerCard}>
          <div className={styles.levelPartnerMetricRow}>
            <span className={`${styles.levelPartnerMetricLabel} ${styles.levelPartnerMetricLabelWithHelp}`}>
              <span className={styles.levelPartnerMetricLabelInline}>
              {affiliatePageDir === "rtl" ? (
                <>
                  <Tooltip
                    title={inviteRuleActiveUserSummary || t("home.referralRulesActiveUserDesc", { depositAmount: "10", depositCurrency: "USDT", tradeVolume: "100", tradeVolumeUnit: "USDT" })}
                    trigger={["hover", "click"]}
                    placement="top"
                    mouseEnterDelay={0.1}
                    overlayInnerStyle={{ maxWidth: 280 }}
                    getPopupContainer={() => document.body}
                  >
                    <span
                      className={styles.levelPartnerOpenMarginHelp}
                      role="button"
                      tabIndex={0}
                      aria-label={inviteRuleActiveUserSummary || t("home.referralRulesActiveUserDesc", { depositAmount: "10", depositCurrency: "USDT", tradeVolume: "100", tradeVolumeUnit: "USDT" })}
                    >
                      <QuestionCircleOutlined />
                    </span>
                  </Tooltip>
                  <span className={styles.levelPartnerMetricLabelText}>{t("home.affiliateLevelColDirectValidUsers")}</span>
                </>
              ) : (
                <>
                  <span className={styles.levelPartnerMetricLabelText}>{t("home.affiliateLevelColDirectValidUsers")}</span>
                  <Tooltip
                    title={inviteRuleActiveUserSummary || t("home.referralRulesActiveUserDesc", { depositAmount: "10", depositCurrency: "USDT", tradeVolume: "100", tradeVolumeUnit: "USDT" })}
                    trigger={["hover", "click"]}
                    placement="top"
                    mouseEnterDelay={0.1}
                    overlayInnerStyle={{ maxWidth: 280 }}
                    getPopupContainer={() => document.body}
                  >
                    <span
                      className={styles.levelPartnerOpenMarginHelp}
                      role="button"
                      tabIndex={0}
                      aria-label={inviteRuleActiveUserSummary || t("home.referralRulesActiveUserDesc", { depositAmount: "10", depositCurrency: "USDT", tradeVolume: "100", tradeVolumeUnit: "USDT" })}
                    >
                      <QuestionCircleOutlined />
                    </span>
                  </Tooltip>
                </>
              )}
              </span>
            </span>
            <span className={styles.levelPartnerMetricValue}>{item.directValidCount}</span>
          </div>
          <div className={styles.levelPartnerMetricRow}>
            <span className={`${styles.levelPartnerMetricLabel} ${styles.levelPartnerMetricLabelWithHelp}`}>
              <span className={styles.levelPartnerMetricLabelInline}>
              {affiliatePageDir === "rtl" ? (
                <>
                  <Tooltip
                    title={t("home.affiliateLevelColOpenMarginTip")}
                    trigger={["hover", "click"]}
                    placement="top"
                    mouseEnterDelay={0.1}
                    getPopupContainer={() => document.body}
                  >
                    <span className={styles.levelPartnerOpenMarginHelp} role="button" tabIndex={0} aria-label={t("home.affiliateLevelColOpenMarginTip")}>
                      <QuestionCircleOutlined />
                    </span>
                  </Tooltip>
                  <span className={styles.levelPartnerMetricLabelText}>{t("home.affiliateLevelColOpenMargin")}</span>
                </>
              ) : (
                <>
                  <span className={styles.levelPartnerMetricLabelText}>{t("home.affiliateLevelColOpenMargin")}</span>
                  <Tooltip
                    title={t("home.affiliateLevelColOpenMarginTip")}
                    trigger={["hover", "click"]}
                    placement="top"
                    mouseEnterDelay={0.1}
                    getPopupContainer={() => document.body}
                  >
                    <span className={styles.levelPartnerOpenMarginHelp} role="button" tabIndex={0} aria-label={t("home.affiliateLevelColOpenMarginTip")}>
                      <QuestionCircleOutlined />
                    </span>
                  </Tooltip>
                </>
              )}
              </span>
            </span>
            <span className={styles.levelPartnerMetricValue}>
              {item.openPositionMargin}
              <span className={styles.levelPartnerUsdtUnit}>USDT</span>
            </span>
          </div>
          <div className={styles.levelPartnerMetricRow}>
            <span className={styles.levelPartnerMetricLabel}>{t("home.affiliateLevelColRebateRate")}</span>
            <div
              className={`${styles.levelPartnerMetricValue} ${rebatePackFromStart ? styles.levelPartnerMetricValueRebateRtl : ""}`}
              dir="ltr"
            >
              {item.rebateTiers.length > 0 ? (
                <div className={styles.levelPartnerRebateList}>
                  {item.rebateTiers.map((tier, i) => {
                    const place = rebateTierGridPlacement(i, item.rebateTiers.length, rebatePackFromStart);
                    return (
                      <span
                        key={tier.layer}
                        className={styles.levelPartnerRebateTier}
                        style={{ gridRow: place.gridRow, gridColumn: place.gridColumn }}
                      >
                        <span className={styles.levelPartnerRebateLbl}>L{tier.layer}</span>
                        <span className={styles.levelPartnerRebatePct}>{tier.text}</span>
                      </span>
                    );
                  })}
                </div>
              ) : (
                item.rebateRates
              )}
            </div>
          </div>
          <div className={styles.levelPartnerMetricRow}>
            <span className={styles.levelPartnerMetricLabel}>{t("home.affiliateLevelColAiTradingProfitRebate")}</span>
            <div
              className={`${styles.levelPartnerMetricValue} ${rebatePackFromStart ? styles.levelPartnerMetricValueRebateRtl : ""}`}
              dir="ltr"
            >
              {item.aiCopyRebateTiers.length > 0 ? (
                <div className={styles.levelPartnerRebateList}>
                  {item.aiCopyRebateTiers.map((tier, i) => {
                    const place = rebateTierGridPlacement(i, item.aiCopyRebateTiers.length, rebatePackFromStart);
                    return (
                      <span
                        key={`ai-${tier.layer}`}
                        className={styles.levelPartnerRebateTier}
                        style={{ gridRow: place.gridRow, gridColumn: place.gridColumn }}
                      >
                        <span className={styles.levelPartnerRebateLbl}>L{tier.layer}</span>
                        <span className={styles.levelPartnerRebatePct}>{tier.text}</span>
                      </span>
                    );
                  })}
                </div>
              ) : (
                item.aiCopyRebateRates
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${affiliate_content} affiliate`} dir={affiliatePageDir}>
      <div className={partnershipRank}>
        <h2>{ t("home.partnershipRank") }</h2>
        <p>{ t("home.partnershipRankTip") }</p>
        <div className={level}>
          <div className={styles.levelPartnerStack}>
            {renderPartnerLevelView()}
          </div>
        </div>
        <button type="button" className={styles.inviteButton} onClick={onInviteNow}>
          {t("affiliateAdmin.inviteNow")}
        </button>
      </div>
      <div className={partner}>
        <div className={partnerTitle}>{ t("home.howDoesPartner") }</div>
        {/* <div className="flow">
          <div className="flow_left">
            <div className="flow_left_item">
              <div className="flow_left_item_icon" onClick={()=>setActiveIndex(1)} style={{backgroundImage:`url(${flow_y})`}}></div>
              <div className="flow_left_item_progress">
                {domeWidth && <div className="flow_left_item_progress_inner" style={{height: activeIndex >= 2 ? '40px' : '0' }}></div>}
                {!domeWidth && <div className="flow_left_item_progress_inner" style={{width: activeIndex >= 2 ? '40px' : '0' }}></div>}
              </div>
            </div>
            <div className="flow_left_item">
              <div className="flow_left_item_icon" onClick={()=>setActiveIndex(2)}  style={{backgroundImage:`url(${activeIndex >= '2'? flow_y : flow_n})`}}></div>
              <div className="flow_left_item_progress">
                {domeWidth && <div className="flow_left_item_progress_inner" style={{height: activeIndex >= 3 ? '40px' : '0' }}></div>}
                {!domeWidth && <div className="flow_left_item_progress_inner" style={{width: activeIndex >= 3 ? '40px' : '0' }}></div>}
              </div>
            </div>
            <div className="flow_left_item">
              <div className="flow_left_item_icon" onClick={()=>setActiveIndex(3)}  style={{backgroundImage:`url(${activeIndex >= '3'? flow_y : flow_n})`}}></div>
              <div className="flow_left_item_progress">
                {domeWidth && <div className="flow_left_item_progress_inner" style={{height: activeIndex >= 4 ? '40px' : '0' }}></div>}
                {!domeWidth && <div className="flow_left_item_progress_inner" style={{width: activeIndex >= 4 ? '40px' : '0' }}></div>}
              </div>
            </div>
            <div className="flow_left_item">
              <div className="flow_left_item_icon" onClick={()=>setActiveIndex(4)}  style={{backgroundImage:`url(${activeIndex >= '4'? flow_y : flow_n})`}}></div>
            </div>
          </div>
          <div className="flow_right">
            <div className="flow_right_explain">
              <div className="flow_right_explain_title">
                {renderExplainTitle()}
              </div>
              <div className="flow_right_explain_desc">
                {renderExplainDesc()}
              </div>
            </div>
            <div className="flow_right_rotate">
              <div className="flow_right_rotate_img" style={{backgroundImage:`url(${renderRotateImg()})`}}></div>
            </div>
          </div>
        </div>
        {!domeWidth && <img src={pre} onClick={()=>setActiveIndex(activeIndex - 1)} style={{display: activeIndex > 1 ? 'block' : 'none'}} className={partnerPre} />}
        {!domeWidth && <img src={preDis} style={{display: activeIndex == 1 ? 'block' : 'none'}} className={partnerPre} />}
        {!domeWidth && <img src={next} onClick={()=>setActiveIndex(activeIndex + 1)} style={{display: activeIndex < 4 ? 'block' : 'none'}} className={partnerNext} />}
        {!domeWidth && <img src={nextDis} style={{display: activeIndex == 4 ? 'block' : 'none'}} className={partnerNext} />} */}
        <div className={partnerDiagramWrap}>
          <img src={img4} alt="partner" className={partnerDiagramImg} />
        </div>
        <div className={partner_text}>
          <p className={partner_text_title}>{ t("home.applyToPartner3") }</p>
          <p className={partner_text_desc}>{ t("home.applyToPartner3Tip") }</p>
        </div>
      </div>
      <div className={faqContent}>
        <h2 className={recommendTitle}>
          {t("price.offenProblem")}
        </h2>
        <div className={faq}>
          <div className={faqItem}>
            <Collapse
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive ? <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q1. ${t("home.referralHierarchyTitle")}`} className="site-collapse-custom-panel">
                <ReferralHierarchy />
              </Panel>
            </Collapse>
            <Collapse
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive ? <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q2. ${t("home.referralRulesTitle")}`} className="site-collapse-custom-panel">
                <ReferralRules />
              </Panel>
            </Collapse>
            <Collapse 
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive?  <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q3. ${t("home.question5")}`} className="site-collapse-custom-panel">
                <p className={faqItemP}>{ t("home.answer5") }</p>
              </Panel>
            </Collapse>
            <Collapse 
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive?  <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q4. ${t("home.question6")}`} className="site-collapse-custom-panel">
                <p>{ t("home.answer61") }</p>
                <p>{ t("home.answer62") }</p>
                <p>{ t("home.answer63") }</p>
              </Panel>
            </Collapse>
            <Collapse 
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive?  <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q5. ${t("home.question7")}`} className="site-collapse-custom-panel">
                <p>{ t("home.answer7") }</p>
              </Panel>
            </Collapse>
            <Collapse 
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive?  <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q6. ${t("home.question8")}`} className="site-collapse-custom-panel site-collapse-custom-panel1">
                <p>{ t("home.answer8") }</p>
              </Panel>
            </Collapse>
            <Collapse 
              expandIconPosition="end"
              expandIcon={({ isActive }) => (isActive?  <img src={jian} className={jianImg} /> : <img src={jia} className={jiaImg} />)}
              className="site-collapse-custom-collapse"
            >
              <Panel header={`Q7. ${t("home.question9")}`} className="site-collapse-custom-panel site-collapse-custom-panel1">
                <p>{ t("home.answer9") }</p>
              </Panel>
            </Collapse>
          </div>
        </div>
      </div>
      {/* {!profileInfo?.isPartner && <div className={immediate} style={{backgroundImage:`url(${domeWidth? Immediate : Immediate})`}}>
          <h2 className={immediateTitle}>{ t("home.applyToPartner") }</h2>
          <p>{ t("home.applyToPartnerTip") }</p>
          <div className={operate}>
            <a className={logIn} href={loginStatus == 1 ? `${getUrl("/affiliate/application")}` : `${getUrl("/accounts/login"+loginQuery)}`} >
              {loginStatus == 1 ? t("home.promptlyApply") : t("home.logIn")}
            </a> */}
            {/* <a className={commissioner}>
              { t("home.commissioner") }
            </a> */}
          {/* </div>
      </div>} */}
      {/* 分享弹窗恢复时取消注释，并确保已恢复上方 state / onShare / ShareModal import
      {inviteShareUrl && (
        <ShareModal
          isShowModal={isShowShareModal}
          title={`Spikex${t('home.partnerPeople')}`}
          onClose={onShareClose}
          qrUrl={inviteShareUrl}
          shareInfo={shareInfo}
        />
      )}
      */}
    </div>
  );
}

export default Content;
